import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import type { StoreProps } from '../store';

interface FetchStatus {
  hasLoaded: boolean;
  wasFetched: boolean;
  fetch: any;
}

export const useFetch = (
  checkFetchStatus: (state: StoreProps) => (fetchFunction: any) => FetchStatus,
  fetchFunction: any,
) => {
  const dispatch = useDispatch();
  const { hasLoaded, wasFetched, fetch } = useSelector(checkFetchStatus)(() =>
    dispatch(fetchFunction()),
  );
  useEffect(() => {
    fetch();
  });
  return {
    hasLoaded,
    wasFetched,
  };
};
